import { styled } from 'goober';

const StyledButton = styled('button')`
  background: none;
  border: none;
  color: var(--on-accent);
  cursor: pointer;
  font-size: 15px;
  padding: 4px 8px;
  border-radius: 6px;
  opacity: 0.8;
  transition: all 0.2s ease;
  &:hover {
    opacity: 1;
    background: rgba(255, 255, 255, 0.15);
    transform: scale(1.1);
  }
`;

interface ClearButtonProps {
  onClick: () => void;
}

export function ClearButton({ onClick }: ClearButtonProps) {
  return (
    <StyledButton id="iso-clear" data-testid="iso-clear-btn" title="Effacer" onClick={onClick}>
      ✕
    </StyledButton>
  );
}
